export const EVENTS = {
    PURCHASE: 'purchase',
    VIEW_ITEM: 'view_item',
    SELECT_ITEM: 'select_item',
    ADD_TO_CART: 'add_to_cart',
    VIEW_ITEM_LIST: 'view_item_list',
    BEGIN_CHECKOUT: 'begin_checkout',
    ADD_PAYMENT_INFO: 'add_payment_info',
};